import { render, staticRenderFns } from "./ChatBls.vue?vue&type=template&id=fcf2afce&"
import script from "./ChatBls.vue?vue&type=script&lang=js&"
export * from "./ChatBls.vue?vue&type=script&lang=js&"
import style0 from "./ChatBls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports